import { mediaCards } from '@/mocks/homeData';

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            最新电影在线看 · 热门推荐
          </h2>
          <p className="text-sm text-foreground-600 max-w-2xl mx-auto">
            每日精选最新电影在线看、热门电视剧全集追踪和综艺节目在线播放内容，帮你快速发现值得看的好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mediaCards.map((card) => (
            <article
              key={card.id}
              className="bg-background-50 border border-background-200/70 rounded-lg overflow-hidden group cursor-pointer transition-all hover:border-primary-200"
            >
              <div className="aspect-video bg-background-200 overflow-hidden relative">
                <img
                  src={card.image}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.currentTarget as HTMLImageElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3 flex gap-2">
                  <span className="px-2.5 py-1 text-xs font-medium bg-primary-500/90 text-background-50 rounded-full">
                    {card.tag}
                  </span>
                  {card.hot && (
                    <span className="px-2.5 py-1 text-xs font-medium bg-accent-500/90 text-background-50 rounded-full">
                      热门
                    </span>
                  )}
                </div>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity">
                  <span className="w-14 h-14 flex items-center justify-center bg-background-50/90 rounded-full">
                    <i className="ri-play-fill text-2xl text-primary-600"></i>
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="font-heading text-base text-foreground-950 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                  {card.summary}
                </p>
                <div className="flex items-center justify-between text-xs text-foreground-500">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {card.duration}
                  </span>
                  <span className="px-2 py-0.5 bg-background-100 text-foreground-600 rounded">
                    {card.category}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}